import React from "react";
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome';


export default function CommentIcon({ count }) {
  const onCommentClick = e => {
    e.preventDefault();
    const el = document.querySelector('#comments');
    window.scrollTo({top: el.offsetTop - 80, behavior: 'smooth'});
  };

  return <a href="#comments" onClick={onCommentClick} aria-label={count === 1 ? 'Kommentar' : 'Kommentare'}>
          {count ?? 0}
          <FontAwesomeIcon 
            aria-hidden 
            title={count === 1 ? 'Kommentar' : 'Kommentare'} 
            icon="comments" 
            size="lg" 
            style={{marginLeft: '.25em'}}/>                                          
         </a>;  
}